import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { MF_REDUX_ACTION_EVENT } from '..';
import useEventListener from '../useEventListener';
export default function useMfReduxActionDispatcher(currentDispatcher, ignoredActions) {
  const dispatch = useDispatch();
  const handleExternalAction = useCallback(({
    detail
  }) => {
    var _detail$action, _detail$action$meta;
    if (detail != null && (_detail$action = detail.action) != null && (_detail$action$meta = _detail$action.meta) != null && _detail$action$meta.dispatcher && detail.action.meta.dispatcher !== currentDispatcher) {
      if (!(ignoredActions != null && ignoredActions.includes(detail.action.type))) {
        dispatch(detail.action);
      }
    }
  }, [dispatch, currentDispatcher, ignoredActions]);
  useEventListener(MF_REDUX_ACTION_EVENT, handleExternalAction);
}